import React from 'react';
import styles from './Livery.module.scss';

function Livery({ cars, onChange }) {
  return (
    <div className={styles.cars}>
      {cars.map( (car, index) => (
        <div className={styles.car} key={index}>
          <input id={`car${index}`} type="radio" name="car" value={car.src} defaultChecked={index === 0} onChange={onChange.bind(null, car)}/>
          <label className={styles.carLabel} htmlFor={`car${index}`}>
            <img className={styles.carImage} src={car.src} alt=""/>
          </label>
        </div>
      ))}
    </div>
  );
}

export default Livery;